export enum OrderType {
  QUICK = 'QUICK',
  AMO = 'AMO',
  LIMIT = 'LIMIT',
  SL = 'SL',
  REPEAT_ORDER = 'REPEAT_ORDER',
  MARKET = 'MARKET'
}
